import { render } from "./EventCreateForm.vue?vue&type=template&id=4d5cd8c5&scoped=true"
import script from "./EventCreateForm.vue?vue&type=script&lang=js"
export * from "./EventCreateForm.vue?vue&type=script&lang=js"

import "./EventCreateForm.vue?vue&type=style&index=0&id=4d5cd8c5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d5cd8c5"]])

export default __exports__